import T from '../basic-components/text';
import { useSnackbar } from 'notistack';

export const useNotify = () => {
  const { enqueueSnackbar } = useSnackbar();
  const MessageStatuses = {
    Error: 'error',
    Success: 'success',
    Warning: 'warning',
    Info: 'info',
  };

  const anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'left',
  };
  const options = {
    anchorOrigin: anchorOrigin,
    hideIconVariant: true,
    autoHideDuration: 3000,
  };

  const error = (message) => {
    if (message instanceof Error)
      enqueueSnackbar(<T>{message.message}</T>, { variant: MessageStatuses.Error, ...options });
    else enqueueSnackbar(message, { variant: MessageStatuses.Error, ...options });
  };
  const success = (message) => enqueueSnackbar(message, { variant: MessageStatuses.Success, ...options });
  const warning = (message) => enqueueSnackbar(message, { variant: MessageStatuses.Warning, ...options });

  return { error, success, warning };
};
